import { SmileOutlined } from '@ant-design/icons';
import { notification } from 'antd';

export const openNotification = (title:String,subTitle:String) => {
  notification.open({
    message: title,
    description:
    subTitle,  
    placement:'topLeft' 
  });
};